import { createSlice } from '@reduxjs/toolkit';
import { ProfileEntity } from '@interpals/api-web';

import { OptionsItem } from 'utils/options';
import { logout } from 'redux/auth/actions';

import { clearPeople, searchPeople, setPeopleIsLoading } from './actions';

export type TagOption = { label: string; value: string; cat_id: string };

export interface PeopleSearchFilters {
    sort?: 'modified' | 'last_login' | 'signup' | 'distance';
    order?: 'asc' | 'desc';
    sex?: 'male' | 'female';
    countries?: string;
    home_countries?: string;
    continents?: string;
    city?: OptionsItem;
    home_city?: OptionsItem[];
    location?: string;
    radius?: number;
    age1?: number;
    age2?: number;
    lfor?: string[];
    known?: string;
    knownlevelmin?: number;
    knownlevelmax?: number;
    learn?: string;
    learnlevelmin?: number;
    learnlevelmax?: number;
    username?: string;
    text?: string;
    learn_match_all?: boolean;
    online?: boolean;
    new?: boolean;
    limit?: number;
    offset?: number;
    photo?: boolean;
    tag_ids?: TagOption[];
}

export interface PeopleState {
    results: ProfileEntity[];
    hasMore: boolean;
    isLoading: boolean;
}

const initialState: PeopleState = {
    results: [],
    hasMore: true,
    isLoading: true,
};

const PAGE_LIMIT = 10;

const peopleFilterSlice = createSlice({
    name: 'people',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(searchPeople.fulfilled, (state, { payload, meta: { arg } }) => {
            if (arg.offset === 0) {
                state.results = payload;
            } else {
                // Filter out duplicate profiles that may be returned by the API
                // across multiple batches
                const updatedResults = [...state.results, ...payload];

                state.results = updatedResults.reduce<ProfileEntity[]>((acc, curr) => {
                    if (!acc.some((item) => item.id === curr.id)) {
                        acc.push(curr);
                    }

                    return acc;
                }, []);
            }

            state.hasMore = payload.length === PAGE_LIMIT;
        });

        builder.addCase(clearPeople, (state) => {
            state.results = [];
        });

        builder.addCase(setPeopleIsLoading, (state, { payload }) => {
            state.isLoading = payload;
        });

        builder.addCase(logout.fulfilled, () => {
            return initialState;
        });
    },
});

export default peopleFilterSlice.reducer;
